import axios from 'axios'

const LOCAL_URL = process.env.REACT_APP_LOCALHOST
const API_TOKEN = localStorage.getItem('api_token') || ''

export const PROPERTY_PAYMENTS = `${LOCAL_URL}/transactions/propertyPayments`

// function to get property payments
export async function getPropertyPayments() {
  return await axios.get(PROPERTY_PAYMENTS)
}